<!-- Main Button with the name of the Function -->
<div style="margin: 2px">
	<button (click)="buttonClicked()" class="btn btn-ef" style="width: 400px; margin-left: 20px" id="object7_function13_button">{{function.name}}</button>
</div>


<!-- Parameters -->
<div *ngIf="functionParameterData.length > 0 && mParametersDisplayed" id="{{ getFunctionParametersTabId() }}"
	class="objectFunctionParametersPane">

	<!-- Loop parameters -->
	<ng-container *ngFor="let param of functionParameterData">

		<div class="row parameter-row">

			<!-- Parameter Label -->
			<div class="col-sm-4 parameter-label">
				{{ param?.functionParameter?.name }}
			</div>

			<div class="col-sm-8">

				<!-- Loop values (datum) -->
				<ng-container *ngFor="let datum of param.dataObjects; let i = index">

					<!-- BOOLEAN -->
					<ng-container *ngIf="param.functionParameter?.type?.toLowerCase() === 'boolean'">
						<input type="checkbox" [(ngModel)]="datum.value"
							style="width: 20px; height: 20px; margin-top: 6px;" />
					</ng-container>

					<!-- REFERENCE TYPES -->
					<ng-container *ngIf="
            param.functionParameter?.type === 'LOCATION_REFERENCE' ||
            param.functionParameter?.type === 'ZONE_REFERENCE' ||
            param.functionParameter?.type === 'READER_REFERENCE' ||
            param.functionParameter?.type === 'TAG_REFERENCE' ||
			param.functionParameter?.type === 'OBJECT_REFERENCE'
          ">
						<input type="text" class="form-control" [ngModel]="datum.object_value?.name || ''"
							(ngModelChange)="onInputChange($event, datum, param.functionParameter)"
							[typeahead]="datum.instanceResults$" [typeaheadAsync]="true" [typeaheadOptionField]="'name'"
							(typeaheadOnSelect)="onInstanceSelected($event, datum)"
							placeholder="Search {{ param.functionParameter.name }}..." />
					</ng-container>

					<!-- FALLBACK NORMAL INPUT -->
					<ng-container *ngIf="
            param.functionParameter?.type.toLowerCase() !== 'boolean' &&
            param.functionParameter?.type !== 'LOCATION_REFERENCE' &&
            param.functionParameter?.type !== 'ZONE_REFERENCE' &&
            param.functionParameter?.type !== 'READER_REFERENCE' &&
            param.functionParameter?.type !== 'TAG_REFERENCE'
          ">
						<input type="text" class="form-control" [(ngModel)]="datum.value" />
					</ng-container>

				</ng-container>
			</div>

		</div>

	</ng-container>

	<!-- Execute Button -->
	<div class="execute-button-container">
		<button class="btn btn-ef execute-button" (click)="executeFunction()">
			Execute: {{ function.name }}
		</button>
	</div>
</div>
<app-function-executing-dialog #functionDialog></app-function-executing-dialog>